$(function() {
	let advantages = $('.advantages');
	let advantagesItem = $('.advantages__item');

	if (advantages.length > 0 && $(window).width() > 1600 && advantagesItem.length < 5) {
		advantagesItem.parent().addClass('grid-2');
	}
})